export { default } from './src/modal-window';
